module.exports = __webpack_public_path__ + "img/student.924da362.png";